require('./bootstrap');
require('./helpers');

import Vue from 'vue'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import { createInertiaApp } from '@inertiajs/vue2'

Vue.config.productionTip = false
Vue.mixin({ methods: { route: window.route } })
Vue.use(PortalVue)
Vue.use(VueMeta)

// Primevue 2
import "primeflex/primeflex.css";
import "primevue/resources/primevue.min.css";
// import "primevue/resources/themes/saga-blue/theme.css";
import "primeicons/primeicons.css";
import "./primevue2_saga_blue_theme.css";

import PrimeVue from 'primevue/config';
Vue.use(PrimeVue, {ripple: true});

import ToastService from 'primevue/toastservice';
Vue.use(ToastService);

import Ripple from "primevue/ripple";
Vue.directive("ripple", Ripple);

import Tooltip from "primevue/tooltip";
Vue.directive("tooltip", Tooltip);

import Styleclass from "primevue/styleclass";
Vue.directive("styleclass", Styleclass);

import BadgeDirective from "primevue/badgedirective";
Vue.directive("badge", BadgeDirective);

import contenteditable from 'vue-contenteditable'
Vue.use(contenteditable)

import ConfirmationService from 'primevue/confirmationservice';
Vue.use(ConfirmationService);

import Router from 'vue-router';
Vue.use(Router);

// const el = document.getElementById('app')
// new Vue({
//     metaInfo: {
//         titleTemplate: title => (title ? `${title} - Longardier` : 'Longardier'),
//     },
//     render: h =>
//         h(App, {
//             props: {
//                 initialPage: JSON.parse(el.dataset.page),
//                 resolveComponent: name => require(`./Pages/${name}`).default,
//             },
//         }),
// }).$mount(el)

createInertiaApp({
    id: 'app',
    resolve: name => require(`./Pages/${name}`),
    setup({ el, App, props, plugin }) {
        Vue.use(plugin)
        new Vue({
            render: h => h(App, props),
        }).$mount(el)
    },
    progress: {
        color: '#2196f3',
    },
})
